function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.833 5.642a.584.584 0 0 0-.502-.391l-3.319-.484L7.525 1.75a.583.583 0 0 0-1.05 0L4.987 4.76l-3.32.49a.583.583 0 0 0-.472.397.583.583 0 0 0 .146.583l2.41 2.333-.584 3.314a.583.583 0 0 0 .846.624L7 10.944l2.975 1.564c.081.046.174.07.268.07a.584.584 0 0 0 .577-.695l-.583-3.313 2.41-2.333a.583.583 0 0 0 .186-.595ZM9.245 7.975a.583.583 0 0 0-.169.52l.42 2.443-2.193-1.166a.583.583 0 0 0-.548 0L4.56 10.938l.42-2.444a.583.583 0 0 0-.169-.519l-1.75-1.75 2.456-.356a.583.583 0 0 0 .443-.32L7 3.325l1.096 2.228a.583.583 0 0 0 .444.321l2.455.356-1.75 1.744Z",
  fill: "#EDB900"
});

function SvgIconEstrela(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEstrela);
export default __webpack_public_path__ + "static/media/icon-estrela.f0b1c2b9a81079cde8e7d672104e3436.svg";
export { ForwardRef as ReactComponent };